import React from 'react';
import { ScenarioPreset } from '../data';

interface ScenarioToggleProps {
  value: ScenarioPreset;
  onChange: (value: ScenarioPreset) => void;
}

const presets: { value: ScenarioPreset; label: string; shortLabel: string; isExtreme?: boolean }[] = [
  {
    value: 'stocksWin',
    label: 'Stocks Outperform',
    shortLabel: 'Stocks'
  },
  {
    value: 'balanced',
    label: 'Balanced',
    shortLabel: 'Balanced'
  },
  {
    value: 'realEstateWins',
    label: 'RE Outperforms',
    shortLabel: 'RE'
  },
  {
    value: 'bothStagnate',
    label: 'Both Stagnate',
    shortLabel: 'Stagnate',
    isExtreme: true
  },
  {
    value: 'bothBoom',
    label: 'Both Boom',
    shortLabel: 'Boom',
    isExtreme: true
  },
];

export const ScenarioToggle: React.FC<ScenarioToggleProps> = ({ value, onChange }) => {
  const mainPresets = presets.filter(p => !p.isExtreme);
  const extremePresets = presets.filter(p => p.isExtreme);

  return (
    <>
      {/* Mobile: Dropdown select */}
      <div className="lg:hidden w-full relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value as ScenarioPreset)}
          className="w-full px-3 py-2.5 pr-10 text-sm font-medium border border-gray-300 bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-400 appearance-none"
        >
          <optgroup label="Main Scenarios">
            {mainPresets.map((preset) => (
              <option key={preset.value} value={preset.value}>
                {preset.label}
              </option>
            ))}
          </optgroup>
          <optgroup label="Extreme Scenarios">
            {extremePresets.map((preset) => (
              <option key={preset.value} value={preset.value}>
                {preset.label}
              </option>
            ))}
          </optgroup>
        </select>
        <svg
          className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>

      {/* Desktop: Button toggle */}
      <div className="hidden lg:inline-flex items-center">
        <div className="inline-flex border border-gray-300">
          {mainPresets.map((preset, index) => (
            <button
              key={preset.value}
              onClick={() => onChange(preset.value)}
              className={`
                px-4 py-2 text-sm font-medium transition-all duration-200
                ${index > 0 ? 'border-l border-gray-300' : ''}
                ${value === preset.value
                  ? 'bg-gray-900 text-white'
                  : 'bg-white text-gray-600 hover:bg-gray-50'
                }
              `}
            >
              {preset.label}
            </button>
          ))}
        </div>
        <span className="mx-2 text-gray-300">|</span>
        <div className="inline-flex border border-gray-200">
          {extremePresets.map((preset, index) => (
            <button
              key={preset.value}
              onClick={() => onChange(preset.value)}
              className={`
                px-3 py-2 text-sm transition-all duration-200
                ${index > 0 ? 'border-l border-gray-200' : ''}
                ${value === preset.value
                  ? 'bg-gray-700 text-white'
                  : 'bg-gray-50 text-gray-500 hover:bg-gray-100'
                }
              `}
            >
              {preset.label}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default ScenarioToggle;
